import { openLogin } from "../../services/service-login";

export default class Header {
  constructor(element) {
    this.el = element;
    this.body = document.querySelector("body");
    this.main = document.querySelector("main");
    this.loginButtons = this.el.querySelectorAll("[data-login]");
    this.loginPopup = document.querySelector("[data-loginpopup]");
    this.searchButton = this.el.querySelectorAll("[data-searchbutton]");
    this.searchArea = this.el.querySelector("[data-searcharea]");
    this.messageCounter = this.el.querySelectorAll("[data-messagecounter]");
    this.searchInput = this.el.querySelector("#global-search");
    this.setScrollDirection = this.setScrollDirection.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.getMessageNumber = this.getMessageNumber.bind(this);
    this.insertMessageNumber = this.insertMessageNumber.bind(this);
    this.message = (this.el.dataset.message === "True");
    this.isEmployee = (this.el.dataset.employee === "True");
    this.isImpersonating = (this.el.dataset.isimpersonating === "True");
    this.isAuth = (this.el.dataset.message === "True");

    this.init();
  }

  init() {
    this.setScrollDirection();
    if ((!this.isEmployee && this.isAuth) || (this.isEmployee && this.isImpersonating)) {
      this.getMessageNumber();
    }
    if (this.loginButtons) {
      this.loginButtons.forEach((button) => {
        let disabled = button.dataset.isDisabled;
        if (disabled === "True") {
          button.classList.add("cursor-not-allowed");
          //remove href from button
          button.removeAttribute("href");
        }
      });

      if (this.searchButton) {
        this.searchButton.forEach((button) => {
          button.addEventListener("click", (e) => {
            this.toggleSearch();
          });
        });
      }

      window.addEventListener(
        "scroll",
        () => {
          document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
        },
        { passive: true }
      );
    }
  }

  getMessageNumber() {
    if (this.messageCounter && this.message == true) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch("/api/memberdata/GetUnreadPost", requestOptions)
        .then((response) => response.json())
        .then((result) => this.insertMessageNumber(result))
        .catch((error) => console.log("error", error));
    }
  }

  insertMessageNumber(messageNumber) {
    this.messageCounter.forEach((messageContainer) => {
      messageContainer.innerHTML = messageNumber;
      if (Number(messageNumber) > 9) {
        messageContainer.classList.remove("h-3");
        messageContainer.classList.add("p-1");
        messageContainer.classList.add("-translate-y-1");
        messageContainer.classList.remove("translate-y-1");
      }
    });
  }

  toggleSearch() {
    let menuHeight = this.el.offsetHeight + "px";
    if (this.body.classList.contains("search")) {
      let scrollY = this.body.style.top;
      this.body.classList.remove("search");
      this.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
      this.searchArea.style.height = null;
      this.searchArea.classList.add("border-t-0");
      this.searchArea.classList.remove("border-t");
      this.searchArea.classList.add("hidden");
    } else {
      let scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
      //console.log('scrollY: ', scrollY)
      this.body.classList.add("search");
      this.searchArea.classList.remove("hidden");
      this.body.style.top = `-${scrollY}`;
      this.searchArea.style.height = "calc(100vh - " + menuHeight + ")";
      this.searchArea.classList.remove("border-t-0");
      this.searchArea.classList.add("border-t");
      this.searchInput.focus();
    }
  }

  setScrollDirection() {
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      if (!this.body.classList.contains("search")) {
        const currentScroll = window.pageYOffset;

        if (currentScroll == 0) {
          this.body.classList.remove(scrollDown);
        }
        if (currentScroll <= 0) {
          this.body.classList.remove(scrollUp);
          return;
        }

        if (currentScroll > lastScroll) {
          // down
          this.body.classList.remove(scrollUp);
          this.body.classList.add(scrollDown);
        } else if (this.body.classList.contains(scrollDown)) {
          // up
          this.body.classList.remove(scrollDown);
          this.body.classList.add(scrollUp);
        }

        lastScroll = currentScroll;
      }
    });
  }
}
